<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11IbgNP/tc-custom/9780830897513.jpg?1696870402121" alt="This image is the cover for the book Colossians, 1-2 Thessalonians, 1-2 Timothy, Titus, Philemon, Ancient Christian Commentary on Scripture"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Colossians, 1-2 Thessalonians, 1-2 Timothy, Titus, Philemon, Ancient Christian Commentary on Scripture
      </h1>
      <p class="bookDescription body article font2">
        <p> <strong> <em>Christianity Today</em> Book of the Year</strong> </p> <p> <strong>For the early church fathers, certain passages in the shorter letters of St. Paul proved particularly important in doctrinal disputes and practical church matters.</strong> Pivotal in controversies with the Arians and the Gnostics, the most commented-on christological text in these letters was Colossians 1:15-20, where Jesus is declared "the image of the invisible God, the firstborn of all creation."</p> <p>The fathers found ample support scattered throughout the Pastorals for the divinity of the Son and the Spirit and for the full union of humanity and divinity in the "one mediator between God and men, the man Christ Jesus" (1 Timothy 2:5). These commentators also looked to the Pastorals for important teaching on ethics and church life.</p> <p>Chief among the Eastern commentators and widely excerpted throughout this volume is John Chrysostom, praised for his pastoral insight. Other Greek commentators cited include Theodoret of Cyr, Theodore of Mopsuestia, Severian of Gabala, Ignatius of Antioch, Justin Martyr, Irenaeus, Clement of Alexandria, Athanasius, Basil the Great, Gregory of Nazianzus, and Gregory of Nyssa. Western commentators include Augustine, Ambrosiaster, Pelagius, Jerome, Hippolytus, Tertullian, Novatian, Cyprian of Carthage, Hilary of Poitiers, and Ambrose. Of particular interest for their ascetical and devotional insight are works from Syrian and Egyptian churches, including Aphrahat, Ephrem the Syrian, Isaac of Nineveh, and Philoxenus of Mabbug.</p> <p>This Ancient Christian Commentary on Scripture volume opens up a treasure house of ancient wisdom that allows these faithful witnesses, some appearing here in English translation for the first time, to speak with eloquence and intellectual acumen to the church today.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Peter J. Gorday, Thomas C. Oden
      </h2>
      
      <p class="authorDescription body article"><p>Peter J. Gorday (PhD, Vanderbilt) is a priest of the Episcopal Church and serves parishes in Georgia and North Carolina. A clinical staff member with the Georgia Association for Pastoral Counseling, he is also the author of <em>Principles of Patristic Exegesis: Romans 9-11 in Origen, John Chrysostom and Augustine</em>, as well as journal articles in the history of biblical interpretation.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8f68c16e